const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';
/* eslint-disable */
const OpenLoginPopup = {
	/**
	 * @desc Initialize
	 */
	$domBody: $('body'),
	$domForm: $('#loginform'),
	$domSubmit: $('input[name=wp-submit]'),
	$domSubmitText: $('js-login-submit-button-text'),
	$domMenu: $('.js-nav-outer'),
	$domMenuBtn: $('.js-menu-btn'),
	classPreventScroll: 'prevent-scroller',
	init:function() {
		OpenLoginPopup.$domSubmit.addClass('btn-disabled');
		OpenLoginPopup.$domSubmitText.addClass('btn-disabled');
		this.openLoginPopup();
		this.checkLoginFailed();
		this.closeLoginPopupIcon();
		Global.escKey(OpenLoginPopup.closeLoginPopup);
		this.closeMenuOnOutsideContainerClickLogin();
		this.showPasswordLogin();
		$('.site-header__login-inner .site-header__login-bottom-link-forgot, .site-header__login-inner .login-remember').wrapAll('<div class="login-wrapper__middle"></div>');
		$('<span></span>').appendTo('.site-header__login-inner .login-remember label');
		this.bind();
		this.onSubmitForm();
	},
	/**
	 * @desc On click open login popup
	 */
	openLoginPopup: function() {
		$('.js-open-login-popup').on('click', (e)=>{
			if ($('.js-login-text-exist').length >= 1) {
				$('.js-open-popup').show();
				$('.js-site-header__login-inner-popup').addClass('popup-active');
				OpenLoginPopup.$domBody.addClass('prevent-scroller');
				OpenLoginPopup.$domMenu.removeClass('is-active');
				OpenLoginPopup.$domMenuBtn.removeClass('is-active');
			}
			if (!$(e.currentTarget).hasClass('js-find-out-more')) {
				Global.removeCookie('find-us', {path: '/'});
			}
		});
		$('.js-find-out-more').on('click', (e)=>{
			if ($('.js-login-text-exist').length >= 1) {
				const state = $(e.currentTarget).attr('data-state');
				document.cookie = `find-us=${state}; path=/`;
				$('.js-open-popup').show();
				$('.js-site-header__login-inner-popup').addClass('popup-active');
				OpenLoginPopup.$domBody.addClass('prevent-scroller');
				OpenLoginPopup.$domMenu.removeClass('is-active');
				OpenLoginPopup.$domMenuBtn.removeClass('is-active');
			}
		});
	},

	bind: function() {
		$('.js-site-header__login-inner-popup').find('input.input').on('input change', function(){
			OpenLoginPopup.updateSubmitButton();
		});
	},

	validateForm: function() {
		const form = OpenLoginPopup.$domForm.serializeArray();
		if (form[0].value === '') {
			return 'The username is empty!';
		}
		if (form[1].value === '') {
			return 'The password is empty!';
		}
		return true;
	},

	updateSubmitButton: function() {
		OpenLoginPopup.$domSubmit.toggleClass('btn-disabled', OpenLoginPopup.validateForm() !== true);
		OpenLoginPopup.$domSubmitText.toggleClass('btn-disabled', OpenLoginPopup.validateForm() !== true);

	},

	onSubmitForm: function() {
		OpenLoginPopup.$domSubmit.on('click', ()=>{
			if (OpenLoginPopup.$domSubmit.hasClass('btn-disabled')) {
				// $('.js-login-error-holder').css('display', 'none');
				$('.js-empty-login-field-error').empty();
				if ($('#user_login').val().trim() === '' && $('#user_pass').val().trim() === '') {
					$('.js-login-error-holder').css('display', 'none');
					$('.js-empty-login-field-error').text('Username and password are empty!');
				}
				if ($('#user_login').val().trim() === '' && $('#user_pass').val().trim() !== '') {
					$('.js-login-error-holder').css('display', 'none');
					$('.js-empty-login-field-error').text('The username is empty!');
				}
				if ($('#user_pass').val().trim() === '' && $('#user_login').val().trim() !== '') {
					$('.js-login-error-holder').css('display', 'none');
					$('.js-empty-login-field-error').text('The password is empty!');
				}
				return false;
			}
			return true;

		});
	},

	checkLoginFailed: function () {
		const cookie = 'login-failed';
		const cookieExpiration = 'login-expired';
		const failed = parseInt(Global.getCookie(cookie)) === 1;
		const failedExpiration = parseInt(Global.getCookie(cookieExpiration)) === 1;
		if (failed) {
			Global.removeCookie(cookie);
			$('.js-site-header__login-inner-popup').addClass('popup-active');
			OpenLoginPopup.$domBody.addClass('prevent-scroller');
			const errorPlaceholder = document.querySelector('.js-login-error-holder');
			if(errorPlaceholder) {
				errorPlaceholder.style.display = 'flex';
			}
		}
		if (failedExpiration) {
			Global.removeCookie(cookieExpiration);
			$('.js-site-header__login-inner-popup').addClass('popup-active');
			OpenLoginPopup.$domBody.addClass('prevent-scroller');
			const errorPlaceholder = document.querySelector('.js-login-error-expiration');
			if(errorPlaceholder) {
				errorPlaceholder.style.display = 'flex';
			}
		}
	},

	closeLoginPopup: function() {
		OpenLoginPopup.$domBody.removeClass('prevent-scroller');
		// OpenLoginPopup.$domMenu.removeClass('is-active');
		$('.js-site-header__login-inner-popup').removeClass('popup-active');
		Global.removeCookie('find-us', {path: '/'})
	},

	closeLoginPopupIcon: function() {
		$('.js-site-header__login-inner-ico').on('click', function() {
			OpenLoginPopup.closeLoginPopup();
			Global.removeCookie('find-us', {path: '/'})
		});
	},

	closeMenuOnOutsideContainerClickLogin: function() {
		Global.$domBody.on('mouseup', function(e) {
			e.preventDefault();
			const popup = $('.js-site-header__login-inner-popup');
			if (!popup.is(e.target) && popup.has(e.target).length === 0 && !$('.js-site-header__login-inner-ico').is(e.target)) {
				OpenLoginPopup.closeLoginPopup();
			}
		});
	},

	showPasswordLogin: function() {
		$('.site-header__login-inner-input-pass-icon').on('click', function() {
			const input = $('.login-password input');
			if (input[0].type === 'password') {
				input[0].type = 'text';
				$(this).addClass('is-active');
			} else {
				input[0].type = 'password';
				$(this).removeClass('is-active');
			}
		});
	},
}
export default OpenLoginPopup;
